export const LANGS = ["JP", "EN", "中文", "한국어"];

export const CATEGORY_LABELS = {
  JP: {
    general: "一般の方",
    influencer: "インフルエンサーの方",
    creator: "クリエイターの方",
  },
  EN: {
    general: "General Guests",
    influencer: "Influencers",
    creator: "Creators",
  },
  中文: {
    general: "普通游客",
    influencer: "网红",
    creator: "内容创作者",
  },
  한국어: {
    general: "일반 고객",
    influencer: "인플루언서",
    creator: "크리에이터",
  },
};

export const TAG_LABELS = {
  JP: {
    monitor: "8.9月予約限定価格",
  },
  EN: {
    monitor: "Aug/Sep Limited Price",
  },
  中文: {
    monitor: "8/9月限定价格",
  },
  한국어: {
    monitor: "8/9월 한정가",
  },
};

export const PRICE_UNITS = {
  JP: {
    group: "グループ",
    person: "人",
  },
  EN: {
    group: "group",
    person: "person",
  },
  中文: {
    group: "团",
    person: "人",
  },
  한국어: {
    group: "그룹",
    person: "1인",
  },
};
